export default __webpack_public_path__ + "static/demographics3-51fa791e904c9242d52587f6c344737e.png";